import en from './en/en.js'
import th from './th/th.js'

export default {
  en,
  th
}
